import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Resource, ResourceResponceDTO } from './models';
import { environment } from '../../../../../environments/environment';
@Injectable()
export class ResourceService {
  private http = inject(HttpClient);

  private baseUrl = environment.host;

  getById(id: string) {
    return this.http.get<Resource>(this.baseUrl + '/api/v1/resource/' + id);
  }

  getSignedUrl(id: string, processed = false) {
    const params = processed ? '?processed=true' : '';
    return this.http.get<{ signedUrl: string }>(
      this.baseUrl + '/api/v1/resource/' + id + '/signedUrl' + params,
    );
  }

  getManifestUrl(id: string) {
    return this.baseUrl + '/api/v1/resource/' + id + '/manifest';
  }

  getAllByCourseId(courseId: string) {
    return this.http.get<ResourceResponceDTO>(
      this.baseUrl + '/api/v1/course/' + courseId + '/resource',
    );
  }

  uploadUrl(payload: {
    name: string;
    url: string;
    type: string;
    courseId?: string;
  }) {
    return this.http.post<{ resourceId: string }>(
      this.baseUrl + '/api/v1/upload/url',
      payload,
    );
  }

  uploadGoogleDriveFile(payload: {
    fileId: string;
    accessToken: string;
    name: string;
    mimeType: string;
    type?: string;
    courseId?: string;
    access?: string;
  }) {
    return this.http.post<{ resourceId: string }>(
      this.baseUrl + '/api/v1/upload/google-drive',
      payload,
    );
  }

  uploadExternalUrl(payload: {
    name: string;
    url: string;
    type: string;
    courseId?: string;
    access?: string;
  }) {
    return this.http.post<{ resourceId: string }>(
      this.baseUrl + '/api/v1/upload/external-url',
      payload,
    );
  }
}
